import { createContext, Dispatch, ReactNode, SetStateAction, useState } from 'react'

export interface LoadingContextProps {
  loading: boolean
  setLoading: Dispatch<SetStateAction<boolean>>
}

export const LoadingContext = createContext({} as LoadingContextProps)

interface LoadingProviderProps {
  children: ReactNode
}

export const LoadingProvider = ({ children }: LoadingProviderProps) => {
  const [loading, setLoading] = useState<LoadingContextProps['loading']>(false)

  const value = {
    loading,
    setLoading
  }

  return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>
}
